module.exports = __webpack_public_path__ + "img/selected2-min.a5ebc1de.png";